import { I18N } from '@/app'
import { Alert } from '@/components/Modals'
import { AppStatus, useAppSelector } from '@/redux'
import { analytics, APIClient } from '@/services'
import { TypeGuards } from '@codeleap/types'

const TRANSITION_STATUS_DONE = 2500

export function GetOrgInvolvedModal({ onDone = null }) {
  const visible = useAppSelector(state => state.AppStatus.modals.getOrgInvolved)

  const toggle = () => {
    AppStatus.setModal('getOrgInvolved')
  }

  const onConfirm = async () => {
    AppStatus.set('loading')

    try {
      analytics.track('get_org_involved')
      await APIClient.Organisations.getOrganisationInvolved()
      await APIClient.Session.QueryKeys.me.refresh()
    } catch (e) {
      logger.error(e)
    }

    setTimeout(() => {
      AppStatus.set('done')
      if (TypeGuards.isFunction(onDone)) onDone()
    }, TRANSITION_STATUS_DONE)
  }

  return (
    <Alert
      debugName='GetOrgInvolvedModal'
      visible={visible}
      toggle={toggle}
      title={I18N.t('modals.getOrganisationInvolved.title')}
      description={I18N.t('modals.getOrganisationInvolved.description')}
      onAction={onConfirm}
      type='warn'
      isRow
      actionButtonProps={{
        text: I18N.t('modals.getOrganisationInvolved.confirm'),
      }}
      dismissButtonProps={{
        text: I18N.t('modals.getOrganisationInvolved.cancel'),
      }}
      styles={{
        modalWrapper: {
          zIndex: 9999,
        },
      }}
    />
  )
}
